module.exports = __webpack_public_path__ + "static/media/Scheduler.55157973.svg";